<template>
	<div>
		<el-drawer title="渠道码" :visible.sync="drawerShow" :wrapperClosable="true" :destroy-on-close="true" size="auto"
			@close="close">
			<div class="drawer-content">
				<template v-if="codeData">
					<h2 class="name">{{codeData.activityName}}</h2>
					<div class="code">
						<vue-qr :logoSrc="logo" :text="codeData.qrCodeUrl" :size="800" :logoMargin="8"
							logoBackgroundColor="#ffffff" :callback="getImage" :margin="0" :correctLevel="3"></vue-qr>
						<input class="copyTool" ref="copyTool" :value="codeData.copyUrl" />
					</div>
					<div class="MT10">
						<el-button size="small" plain type="primary"
							@click="$refs.H5Preview.show(codeData.qrCodeUrl)">直接打开</el-button>
						<el-button type="primary" size="small" @click="copy">复制链接</el-button>
						<el-button type="primary" size="small" @click="downloadCode">下载二维码</el-button>
					</div>
					
					<div class="code MT30" v-if="codeData.wechatCodeUrl">
						<img :src="codeData.wechatCodeUrl" class="img2" ref="img2" @load="handleLoad">
						<input class="copyTool" ref="copyTool" :value="codeData.copyUrl" />
					</div>
					<div class="MT30" v-if="codeData.wechatCodeUrl">
						<el-button type="primary" size="small"
							@click="downloadCodeWechat(codeData.wechatCodeUrl)">下载二维码</el-button>
					</div>
				</template>
			</div>
			<div class="drawer-footer">
				<el-button @click="close">关闭</el-button>
			</div>
		</el-drawer>
		<H5Preview ref="H5Preview"></H5Preview>
	</div>
</template>

<script>
	import VueQr from 'vue-qr';
	import logo from '@/assets/img/logo.png';	
	import H5Preview from '@/components/H5Preview';	
	export default {
		components: {
			VueQr,
			H5Preview
		},
		data() {
			return {
				drawerShow: false,
				codeData: null,
				logo: logo,				
				codeImage: '',
				copyTimer: null,				
				sswap: process.env.VUE_APP_SSWAP_URL,
				wechatcodeLoading: false,
				wechatcodeShow: false,
			}
		},
		methods: {
			close() {
				this.drawerShow = false
			},
			show(obj) {				
				this.codeData = {
					...obj,
					qrCodeUrl: obj.activityLink,
					copyUrl:obj.activityLink,
					wechatCodeUrl:''
				};				
				this.drawerShow = true
				this.getWechatcode()
			},
			handleLoad() {
				this.wechatcodeShow = true
			},
			getImage(url) {
				this.codeImage = url;
			},
			downloadCode() {
				const _data = this.$utils.base64ToBlob(this.codeImage);
				this.$utils.exportFile(_data, `${this.codeData.name}的二维码.png`);
			},
			downloadCodeWechat(imgUrl) {
				const url = imgUrl
				const fileName = this.codeData.name + '-小程序码.jpg'
				this.$utils.downloadImg(url, fileName);
			},
			getWechatcode() {
				this.wechatcodeLoading = true
				this.$request({
					url: "/track/management/getWxQrcode",
					method: "get",
					params: {
						id: this.codeData.id
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.wechatcodeLoading = false
						this.codeData.wechatCodeUrl = result

					}
				})
			},
			//复制链接
			copy() {
				clearTimeout(this.copyTimer);
				this.copyTimer = setTimeout(() => {
					const e = this.$refs.copyTool;
					e.select();
					document.execCommand("Copy"); // 执行浏览器复制命令
					this.$message.success("已复制成功，可粘贴");
				}, 300)
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.drawer-content {
		text-align: center;

		.name {
			font-size: 14px;
			line-height: 20px;
		}

		.code {
			width: 200px;
			height: 200px;
			margin: 30px auto;

			img {
				width: 100%;
				max-width: 100%;
			}
		}
	}

	.copyTool,
	.copyTool2 {
		opacity: 0;
		filter: alpha(opacity=0);
		// height: 1px;
	}

	.posterBox {
		width: 540px;
		height: 720px;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;

		.el-image {
			max-width: 100%;
			max-height: 100%;
		}
	}

	.canvasMain {
		width: 540px;
		position: absolute;
		left: -9999px;
	}

	.canvasFooter {
		width: 540px;
		padding: 11px 18px 15px 18px;
		background: #fff;
		display: flex;
		justify-content: space-between;
	}

	.imgSize {
		height: 75px;
		width: 423px;
	}

	.codeMain {
		width: 64px;
		height: 80px;
		background: #ff3342;
		border-radius: 4px;

		.imgQr {
			background: #fff;
			margin: 2px 0 0 2px;
			width: 60px;
			height: 60px;

			.el-image {
				margin-top: 3px;
				width: 55px;
				height: 55px;
			}
		}

		.footImgcode {
			margin-top: 3px;
			max-width: 58px;
			max-height: 58px;
		}

		.footText {
			width: 64px;
			height: auto;

			.el-image {
				margin: 5px auto 0 auto;
				width: 39px;
				height: 8px;
				display: block;
			}
		}

	}
</style>